
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("kNA4T", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=en-US.186580eb.js.map
